export type AgreementDataDocument = {
  document: object
  id: string
  name: string
  type: string
}

export type AgreementData = AgreementDataDocument[]

export const AgreementTypes = [
  'eft_agreement',
  'paypal_agreement',
  'partner_agreement',
  'program_agreement',
  'spend_electronic_funds_transfers_disclosure',
  'spend_esign_consent',
  'spend_funds_availability',
  'spend_privacy_policy',
  'spend_terms_and_conditions',
  'spend_truth_in_savings_disclosure',
  'acorns_privacy_policy',
]
